export const FACEBOOK_COLOR = '#1877F2';
export const LINKEDIN_COLOR = '#0A66C2';
export const TWITTER_COLOR = '#1DA1F2';
